import React from 'react';
import classNames from 'classnames';
import useFeatureFlags from 'hooks/useFeatureFlags';
import CompanySwitcher from 'components/shared/CompanySwitcher';
import MobileAppSwitcher from 'components/shared/MobileAppSwitcher';

const NavLink = ({ isActive, path, params, children, pendoClassName }) => {
  const hasUnification = useFeatureFlags('readiness-enable-unification');
  return (
    <li className={classNames({ active: isActive })}>
      <a
        className={classNames({
          unification: hasUnification,
          [pendoClassName]: pendoClassName,
        })}
        href={params ? path + params : path}
      >
        {children}
        <div className="active-bar" />
      </a>
    </li>
  );
};

const NavbarMenu = ({
  currentCompany,
  currentPath,
  navLinks,
  navbarCollapsed,
  linkedUsers,
  hasSkills,
}) => {
  const isActiveNavLink = path =>
    currentPath === path || currentPath.startsWith(path + '?');

  return (
    <ul className="nav navbar-nav">
      {hasSkills && navbarCollapsed && (
        <li className="m-m-0">
          <MobileAppSwitcher />
        </li>
      )}
      {linkedUsers && (
        <li className="company-switcher m-m-0">
          <CompanySwitcher expandedView={!navbarCollapsed} />
        </li>
      )}
      {navbarCollapsed && (hasSkills || linkedUsers) && (
        <li className="divider" />
      )}
      {navLinks
        .filter(navLink => navLink)
        .map(
          ({
            path,
            params,
            label,
            isActive = isActiveNavLink,
            pendoClassName,
          }) => {
            return (
              <NavLink
                key={'navlink' + path}
                isActive={isActive(path)}
                path={path}
                params={params}
                pendoClassName={pendoClassName}
              >
                {label}
              </NavLink>
            );
          },
        )}
    </ul>
  );
};

export default NavbarMenu;
